export default "__VITE_ASSET__CVcV6nLT__"